import { GridAction } from '@eforall/dashboard';
import { EmailJobTrigger } from '@interfaces';

export function getActions() {

	const actions: GridAction<EmailJobTrigger & { updatedUTC: number }>[] = [];

	return actions;
}